  import React, { useEffect } from "react";
  import {
    BrowserRouter,
    Routes,
    Route,
    Navigate,
    useLocation,
  } from "react-router-dom";
  import { useSelector } from "react-redux";
  import { createBrowserHistory } from "history";
  // core components
  import AppsLayout from "./layouts/Admin";
  import LoginPage from "views/pages/LoginPage.js";
  import Dashboard from "views/pages/Dashboard/Dashboard";
  import OuterLayout from "layouts/OuterLayout";
  import Repayment from "views/pages/Repayment/Repayment";
  import RepaymentLoanDetails from "views/pages/Repayment/ReyamentLoanDetails";
  import CompleteLoanDetailsReview from "views/pages/Review/CompleteLoanDetailsReview";
  import InnnerAdminNewLoan from "./layouts/InnnerAdminNewLoan";
  import IncomeDetails from "views/pages/IncomeDetails/IncomeDetails";
  import GeneralDetails from "views/pages/GeneralDetails/GeneralDetails";
  import Reference from "views/pages/ReferenceDetails/ReferenceDetails";
  import AadharDetails from "views/pages/AadharDetails/AadharDetails";
  import PanDetails from "views/pages/PanDetails/PanDetails";
  import ProfileDetails from "views/pages/ProfileDetails/ProfileDetails";
  import LoanTenureDetails from "views/pages/LoanTenure/LoanTenure";
  import LoanDetails from "views/pages/LoanDetails/LoanDetails";
  import RepaymentScheduleDetails from "views/pages/RepaymentSchedule/RepaymentSchedule";
  import BankDetails from "views/pages/BankDetails/BankDetails";
  import SanctionLetter from "views/pages/SanctionLetter/SanctionLetter";
  import EsignSanctionLetter from "views/pages/SanctionLetter/EsignSanctionLetter";
  import ApprovalDetails from "views/pages/Approval/ApprovalDetails";
  import CongraculationDetails from "views/pages/CongraculationDetails/CongraculationDeails";
  import DisbursalDetails from "views/pages/DisbursalDetails/DisbursalDetails";
  import MandateDetails from "views/pages/MandateDetails/MandateDetails";
  import SelfieDEtails from "views/pages/SelfieDetails/SelfieDetails";
  import PurposeOfLoan from "views/pages/PurposeOfLoan/PurposeOfLoan";
  import EstampSanctionLetter from "views/pages/SanctionLetter/EstampSanctionLetter";
  import DisbursalInfo from "views/pages/DisbursalDetails/DisbursalInfo";
  import PayNow from "views/pages/Repayment/PayNow";
  import EmiSchedule from "views/pages/Repayment/EmiSchedule";
  import StatementOfAccount from "views/pages/Repayment/StatementOfAccount";
  import PanDetailsVerification from "views/pages/PanDetails";
  import UpdatePanDetails from "views/pages/UpdatePanDetails/UpdatePanDetails";
  import Welcome from "views/pages/Welcome/Welcome";
  import About from "views/pages/About/About";
  import Contact from "views/pages/Contact/Contact";
  import ErrorPage from "views/pages/ErrorPage/ErrorPage";
import PaymentOptions from "views/pages/Repayment/PaymentOptions";
import AadharOAuth2RedirectHandler from "views/components/AadharOAuth2RedirectHandler/AadharOAuth2RedirectHandler";
import LivePhotoAuthRedirectHandler from "views/components/LivePhotoAuthRedirectHandler/LivePhotoAuthRedirectHandler";
import { faviconUrl } from "assets/properties/properties";
import TermsAndConditions from "views/pages/TermAndCondition/TermAndConditions";
import PrivacyPolicy from "views/pages/PrivacyPolicy/PrivacyPolicy";
import PaymentStatus from "views/pages/PaymentStatus/PaymentStatus";
import EsignRedirect from "views/pages/SanctionLetter/EsignRedirect";
import LoanRejected from "views/pages/LoanRejected/LoanRejected";
import { saveAuthData } from "store/reducers/login/LoginSlice";
import { saveUserLeadId } from "store/reducers/login/LoginSlice";
import MandateStatus from "views/pages/MandateDetails/MandateStatus";
import AutoLogin from "layouts/AutoLogin";
import AdminPortal from "views/pages/AdminPortal/AdminPortal";
import PersonalLoanReview from "views/pages/PersonalDataReviewData/PersonalLoanReview";
import BankAnalyzerWrapper from "views/pages/BankAnalyser/BankAnalyzerWrapper";
import PartnerLeadRedirect from "views/pages/PartnerLeadRedirect/PartnerLeadRedirect";
import RejectApplication from "views/pages/AdminPortal/RejectApplication";
import LeadAssignmentTable from "views/pages/AdminPortal/LeadAssignmentTable";

  function RequireAuth({ children }) {
    const {
      authData: { isAuthenticated },
    } = useSelector((state) => state.login);

    const location = useLocation();

    return isAuthenticated ? (
      children
    ) : (
      <Navigate to="/login" state={{ from: location }} replace />
    );
  }
  const updateFavicon = () => {
    const favicon = document.getElementById('dynamic-favicon');
    if (favicon) {
      favicon.href = faviconUrl;
    } else {
      const link = document.createElement('link');
      link.id = 'dynamic-favicon';
      link.rel = 'shortcut icon';
      link.href = faviconUrl;
      document.head.appendChild(link);
    }
};
  export default function App() {
    // const dispatch = useDispatch();

    // useEffect(() => {
    //   const storedAuthData = localStorage.getItem("authToken");
    //   const storedLeadData = localStorage.getItem("leadId");
    //   console.log(localStorage, localStorage,'singlasinglasingla')
    //   if (storedAuthData) {
    //      dispatch(saveAuthData(storedAuthData))
    //   }
    //   if (storedLeadData) {
    //    dispatch(saveUserLeadId(storedLeadData));
    //   }
    // }, [dispatch]);

    const {
      authData: { isAuthenticated },
    } = useSelector((state) => state.login);
    useEffect(()=>{
      updateFavicon()
    },[])


    return (
      <BrowserRouter>
        <Routes>
          <Route
            path="/v1/partner/leads/apply"
            element={<PartnerLeadRedirect />}
          />
          <Route path="/auto/:autoId" element={<AutoLogin />} />
          <Route path="/" element={<Navigate to="/welcome" replace />} />
          <Route path="mandate/success" element={<MandateStatus />} />
          <Route path="mandate/failure" element={<MandateStatus success={false}/>} />
          <Route path="/" element={<OuterLayout />}>
            <Route index element={<Navigate to="/welcome" replace />} />
            <Route path="welcome" element={<Welcome />} />
            <Route path="about" element={<About />} />
            <Route path="contact" element={<Contact />} />
            <Route path="login" element={<LoginPage />} />
            <Route path="panDetails" element={<PanDetailsVerification />} />
            <Route path="term-and-conditions" element={<TermsAndConditions />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/eSign/sucess" element={<EsignRedirect />} />
            <Route path="/eSign/error" element={<EsignRedirect />} />
            <Route path="loanRejected" element={<LoanRejected />} />
          </Route>
          <Route path="/" element={<AppsLayout />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="AdminPortal" element={<AdminPortal />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="repayment" element={<Repayment />} />
            <Route path="repaymentDetails" element={<RepaymentLoanDetails />} />
            <Route path="PaymentSuccess" element={<PaymentStatus status="success"/>} />
            <Route path="PaymentFailed" element={<PaymentStatus status="failed"/>} />
            <Route path="rejectApplication" element={<RejectApplication />} />
            <Route path="leadAssign" element={<LeadAssignmentTable />} />
            <Route
              path="completedDetails"
              element={<CompleteLoanDetailsReview />}
            />
            <Route path="profileDetails" element={<ProfileDetails />} />
            <Route path="EmiSchedule" element={<EmiSchedule />} />
            <Route path="StatementOfAccount" element={<StatementOfAccount />} />
            <Route path="PayNow" element={<PayNow />} />
            <Route path="PaymentOptions" element={<PaymentOptions />} />
            <Route path="UpdatePanDetails" element={<UpdatePanDetails />} />
            <Route path="personalLoanDetails/:loanApplicationId" element={<PersonalLoanReview />} />
          </Route>
          <Route
            path="journey"
            element={
              <RequireAuth>
                <InnnerAdminNewLoan />
              </RequireAuth>
            }
          >
            <Route path="aadhar-oauth" element={<AadharOAuth2RedirectHandler />} />
            <Route path="selfie-liveness" element={<LivePhotoAuthRedirectHandler />} />
            <Route path="incomeDetails" element={<IncomeDetails />} />
            <Route path="aadharDetails" element={<AadharDetails />} />
            <Route path="panPhoto" element={<PanDetails />} />
            <Route path="selfiePhoto" element={<SelfieDEtails />} />
            <Route path="generalDetails" element={<GeneralDetails />} />
            <Route path="BankAnalyser" element={<BankAnalyzerWrapper />} />
            <Route path="purposeOfLoan" element={<PurposeOfLoan />} />
            <Route path="referenceDetails" element={<Reference />} />
            <Route path="ApprovalDetails" element={<ApprovalDetails />} />
            <Route
              path="CongraculationDetails"
              element={<CongraculationDetails />}
            />
            <Route path="loanTenureDetails" element={<LoanTenureDetails />} />
            <Route path="loanDetails" element={<LoanDetails />} />
            <Route
              path="RepaymentScheduleDetails"
              element={<RepaymentScheduleDetails />}
            />
            <Route path="BankDetails" element={<BankDetails />} />
            <Route path="SanctionLetter" element={<SanctionLetter />} />
            <Route
              path="EstampSanctionLetter"
              element={<EstampSanctionLetter />}
            />
            <Route path="EsignSanctionLetter" element={<EsignSanctionLetter />} />
            <Route path="MandateDetails" element={<MandateDetails />} />
            <Route path="DisbursalDetails" element={<DisbursalDetails />} />
            <Route path="DisbursalInfo" element={<DisbursalInfo />} />
          </Route>
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </BrowserRouter>
    );
  }
